import moment from "moment";
import { BiBell } from "react-icons/bi";
import { FaChevronRight } from "react-icons/fa";
import { IoSend } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

export default function TaskTable({ tasks, need, assignToNoNeed, heading }) {
    const formatDueDate = (date) => {
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();
        return `${month}/${day}/${year}`;
    };
    const navigate = useNavigate();
    const getStatusStyle = (status) => {
        if (status === "Pending") return "bg-yellow-100 text-yellow-700";
        if (status === "In Progress") return "bg-blue-100 text-blue-700";
        return "";
    };

    return (
        <div className="min-w-full rounded-lg shadow-md bg-white relative">
            <div className="p-4 flex justify-between items-center">
                <h2 className="text-lg font-semibold">
                    {heading ? "Tasks" : "Tasks & Reminders"}
                </h2>
            </div>

            <div className="overflow-x-auto min-w-full">
                <table className="min-w-full text-left">
                    <thead className="bg-[#361D3214]">
                        <tr className="text-gray-500 text-sm">
                            <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600  min-w-[170px]">
                                Task
                            </th>
                            {!assignToNoNeed ? (
                                <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[200px]">
                                    Assigned To
                                </th>
                            ) : null}
                            <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[160px]">
                                Status
                            </th>
                            <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[100px]">
                                Due Date
                            </th>
                            <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[50px]">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody className="min-w-full text-sm text-gray-800">
                        {tasks.length > 0 && need === true ?

                            tasks?.slice(0, 3).map((task, index) => (
                                <tr key={index} className="border-b last:border-none">
                                    <td className="px-4 py-3 text-sm min-w-[150px]">
                                        {task?.title}
                                    </td>
                                    {!assignToNoNeed ? (
                                        <td className="px-4 py-3 min-w-[150px]">
                                            <span className="text-sm bg-gray-100 text-gray-700 px-3 py-1 rounded">
                                                {typeof (task?.assignedTo) == 'object' ? (task.assignedTo?.name || "Unknown") : (task?.assignedTo || "Unknown")}
                                            </span>
                                        </td>
                                    ) : null}
                                    <td className="px-4 py-3 min-w-[120px]">
                                        <span
                                            className={`text-sm px-3 py-1 rounded ${getStatusStyle(
                                                task.status
                                            )}`}
                                        >
                                            {task.status}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 min-w-[120px]">
                                        {moment(task.dueDate).format("DD-MMM-yy")}
                                    </td>
                                    <td className="px-4 py-3 min-w-[100px]">
                                        {task.status === 'Pending' ?
                                            <button className="flex items-center text-gray-700 border border-gray-300 px-2 py-1 bg-gray-100 rounded hover:bg-gray-300">
                                                <IoSend className="w-3 h-3 mr-1 text-black" />
                                                <span className="text-sm">Remind</span>
                                            </button>
                                            : null}
                                    </td>
                                </tr>
                            ))
                            :
                             tasks?.map((task, index) => (
                                <tr key={index} className="border-b last:border-none">
                                    <td className="px-4 py-3 text-sm min-w-[150px]">
                                        {task?.title}
                                    </td>
                                    {!assignToNoNeed ? (
                                        <td className="px-4 py-3 min-w-[150px]">
                                            <span className="text-sm bg-gray-100 text-gray-700 px-3 py-1 rounded">
                                                {typeof (task?.assignedTo) == 'object' ? (task.assignedTo?.name || "Unknown") : (task?.assignedTo || "Unknown")}
                                            </span>
                                        </td>
                                    ) : null}
                                    <td className="px-4 py-3 min-w-[120px]">
                                        <span
                                            className={`text-sm px-3 py-1 rounded ${getStatusStyle(
                                                task.status
                                            )}`}
                                        >
                                            {task.status}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 min-w-[120px]">
                                        {moment(task.dueDate).format("DD-MMM-yy")}
                                    </td>
                                    <td className="px-4 py-3 min-w-[100px]">
                                        {task.status === 'Pending' ?
                                            <button className="flex items-center text-gray-700 border border-gray-300 px-2 py-1 bg-gray-100 rounded hover:bg-gray-300">
                                                <IoSend className="w-3 h-3 mr-1 text-black" />
                                                <span className="text-sm">Remind</span>
                                            </button>
                                            : null}
                                    </td>
                                </tr>
                            ))
                            }
                    </tbody>
                </table>
            </div>
            {tasks.length === 0 ?
                <p className="p-4 text-gray-800 text-center">No task found</p>
                : null}
            {need && tasks.length > 0 ? (
                <div className="p-4 py-6 flex justify-end">
                    <p
                        onClick={() => {
                            navigate("/tasks-&-reminders", {
                                state: { taskData: tasks },
                            });
                        }}
                        className="text-sm text-black flex items-center cursor-pointer"
                    >
                        View All <FaChevronRight className="ml-1" />
                    </p>
                </div>
            ) : (
                <div className=" pb-2"></div>
            )}
        </div>
    );
}
